import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import screenfull from "screenfull";
import { ToggleFullscreenDirective } from "@shared/directives/toggle-fullscreen.directive";

@Component({
    selector: "my-fullscreen-button",
    templateUrl: "fullscreen-button.component.html",
    styleUrls: ["fullscreen-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ToggleFullscreenDirective]
})
export class FullscreenButtonComponent implements OnDestroy, OnInit {
    public isFullscreen = false;

    private readonly onFullscreenChange = (): void => {
        this.isFullscreen = screenfull.isFullscreen;
    };

    public ngOnInit(): void {
        if (!screenfull.isEnabled) return;

        screenfull.on("change", this.onFullscreenChange);
        this.isFullscreen = screenfull.isFullscreen;
    }

    public ngOnDestroy(): void {
        if (!screenfull.isEnabled) return;

        screenfull.off("change", this.onFullscreenChange);
    }
}
